
const selectors: Record<'footer', string> = {
  footer: '[data-footer]',
}

const mql = window.matchMedia('(min-width: 1024px)');

const init = () => {
  const footer = document.querySelector(selectors.footer)
  if (!footer) return
  const details = Array.from(footer.querySelectorAll('details')) as HTMLDetailsElement[]

  if (!mql.matches) {
      details.forEach(detail => {
        detail.open = false
      })
    }


    mql.addEventListener('change', ({ matches }: { matches: boolean }) => {
      if (matches) {
        details.forEach(detail => detail.open = true)
        return
      }

      details.forEach(detail => detail.open = false)
    })
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init();
  },
  {
    once: true,
  }
);